import { apiClient } from './api-client';
import { ShoppingCartUploadResult } from '@/entities/shopping-cart-upload/ShoppingCartUploadResult';
import { ShoppingCartUploadInfo } from '@/entities/shopping-cart-upload/ShoppingCartUploadInfo';
import URI from 'urijs';

/**
 * Service for shopping cart upload operations.
 */
export class ShoppingCartUploadService {
    private get baseUrl(): string {
        return '/api/shopping-cart-upload';
    }

    public async getCurrentUploadState(): Promise<ShoppingCartUploadInfo> {
        const res = await apiClient.get<ShoppingCartUploadInfo>(`${this.baseUrl}/state`);
        return res.data;
    }

    public async processFile(file: File, includeUsedParts: boolean): Promise<ShoppingCartUploadResult> {
        const formData = new FormData();
        formData.append('fileInput', file);
        const url = includeUsedParts
            ? `${this.baseUrl}/search/includeUsedParts`
            : `${this.baseUrl}/search/excludeUsedParts`;
        const res = await apiClient.post<ShoppingCartUploadResult>(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res.data;
    }

    public async updateItem(partId: string, quantity: number): Promise<void> {
        const url = new URI(`${this.baseUrl}/update`)
            .addQuery('partId', partId)
            .addQuery('quantity', quantity)
            .toString();
        return await apiClient.post(url);
    }
}
